"use strict";

exports.__esModule = true;
exports.VEHICLE_UPDATE_OR_ADD = exports.VEHICLE_UPDATE_MODEL_LIST = exports.VEHICLE_UPDATE_CURRENT_INDEX = exports.VEHICLE_TRIM_LIST = exports.VEHICLE_SELECTED_LIST = exports.VEHICLE_LIST_SHOW_HIDE = exports.VEHICLE_LIST_RESET = exports.VEHICLE_FULL_LIST = exports.VEHICLE_DELETE = void 0;
var VEHICLE_FULL_LIST = 'VEHICLE_FULL_LIST';
exports.VEHICLE_FULL_LIST = VEHICLE_FULL_LIST;
var VEHICLE_TRIM_LIST = 'VEHICLE_TRIM_LIST';
exports.VEHICLE_TRIM_LIST = VEHICLE_TRIM_LIST;
var VEHICLE_SELECTED_LIST = 'VEHICLE_SELECTED_LIST';
exports.VEHICLE_SELECTED_LIST = VEHICLE_SELECTED_LIST;
var VEHICLE_UPDATE_MODEL_LIST = 'VEHICLE_UPDATE_MODEL_LIST';
exports.VEHICLE_UPDATE_MODEL_LIST = VEHICLE_UPDATE_MODEL_LIST;
var VEHICLE_DELETE = 'VEHICLE_DELETE';
exports.VEHICLE_DELETE = VEHICLE_DELETE;
var VEHICLE_UPDATE_CURRENT_INDEX = 'VEHICLE_UPDATE_CURRENT_INDEX';
exports.VEHICLE_UPDATE_CURRENT_INDEX = VEHICLE_UPDATE_CURRENT_INDEX;
var VEHICLE_UPDATE_OR_ADD = 'VEHICLE_UPDATE_OR_ADD';
exports.VEHICLE_UPDATE_OR_ADD = VEHICLE_UPDATE_OR_ADD;
var VEHICLE_LIST_SHOW_HIDE = 'VEHICLE_LIST_SHOW_HIDE';
exports.VEHICLE_LIST_SHOW_HIDE = VEHICLE_LIST_SHOW_HIDE;
var VEHICLE_LIST_RESET = 'VEHICLE_LIST_RESET';
exports.VEHICLE_LIST_RESET = VEHICLE_LIST_RESET;